export const TimingFunction = {
  LINEAR: (timeFraction) => timeFraction,
  EASE_OUT_QUART: (timeFraction) => 1 - Math.pow(1 - timeFraction, 4)
};
